<template>
	<div class="all-wrap">
		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>

		<!-- 顶部 banner 区(站内风格:暗色大图 + 顶部导航) -->
		<div class="videolist-banner">
			<!-- 顶部导航栏 -->
			<Headernew />

			<div class="wow fadeInUp bannertop-title">
				<div>项目方案 · 详情分享</div>
				<div>——后天科技·管理方案、报价、作品与案例</div>
			</div>
		</div>

		<!-- ===================== 页主体：项目方案 · 详情分享 ===================== -->
		<div class="app-container" ref="contentArea">
			<div class="page-header">
				<h1>
					<i class="iconfont icon-shoushimima"></i> 项目方案
				</h1>
			</div>

			<!-- Tab 切换 -->
			<div class="tabs">
				<button v-for="t in tabList" :key="t.key" class="tab-btn"
					:class="{ active: activeTab === t.key }" @click="switchTab(t.key)">
					<i :class="t.icon"></i> {{ t.text }}
				</button>
			</div>

			<!-- ============ 方案面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'scheme'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<input class="search-input" type="text" v-model="schemeName" placeholder="按名称搜索" @keyup.enter="loadScheme" />
						<input class="search-input" type="text" v-model="schemeTags" placeholder="按标签搜索" @keyup.enter="loadScheme" />
						<button class="search-btn" @click="loadScheme"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedScheme.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无方案</p>
					</div>
					<div class="timeline-item" v-for="item in sortedScheme" :key="item.id" @click="toSchemeDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 报价面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'budget'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<input class="search-input" type="text" v-model="budgetName" placeholder="按名称搜索" @keyup.enter="loadBudget" />
						<input class="search-input" type="text" v-model="budgetTags" placeholder="按标签搜索" @keyup.enter="loadBudget" />
						<button class="search-btn" @click="loadBudget"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedBudget.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无报价</p>
					</div>
					<div class="timeline-item" v-for="item in sortedBudget" :key="item.id" @click="toBudgetDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 作品面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'works'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<input class="search-input" type="text" v-model="workName" placeholder="按名称搜索" @keyup.enter="loadWorks" />
						<input class="search-input" type="text" v-model="workTags" placeholder="按标签搜索" @keyup.enter="loadWorks" />
						<button class="search-btn" @click="loadWorks"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedWorks.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无作品</p>
					</div>
					<div class="timeline-item" v-for="item in sortedWorks" :key="item.id" @click="toWorkDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 案例面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'cases'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<input class="search-input" type="text" v-model="caseName" placeholder="按名称搜索" @keyup.enter="loadCases" />
						<input class="search-input" type="text" v-model="caseTags" placeholder="按标签搜索" @keyup.enter="loadCases" />
						<button class="search-btn" @click="loadCases"><i class="iconfont icon-search"></i> 搜索</button>
					</div>
				</div>

				<div class="timeline">
					<div class="empty-state" v-if="sortedCases.length === 0">
						<i class="iconfont icon-dengdai"></i><p>暂无案例</p>
					</div>
					<div class="timeline-item" v-for="item in sortedCases" :key="item.id" @click="toCaseDetail(item.id)">
						<div class="tl-marker"></div>
						<div class="tl-body">
							<div class="tl-date">{{ fmtDate(item.created_at) }}</div>
							<div class="tl-card">
								<div class="tl-title">{{ item.main }}</div>
								<div class="tl-tags">
									<span v-if="item.keys_name">{{ item.keys_name }}</span>
									<span v-for="tg in splitTags(item.tags)" :key="tg">{{ tg }}</span>
								</div>
								<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<!-- 底部页脚(项目统一) -->
		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'

export default {
	name: 'projectProposal',
	components: { Headernew, Footernew, Comment, gotop },
	data() {
		return {
			activeTab: 'scheme',
			tabList: [
				{ key: 'scheme', text: '方案', icon: 'iconfont icon-shipinbofangyingpian' },
				{ key: 'budget', text: '报价', icon: 'iconfont icon-add' },
				{ key: 'works', text: '作品', icon: 'iconfont icon-dianying' },
				{ key: 'cases', text: '案例', icon: 'iconfont icon-Dmoxingx' },
			],

			// 列表数据(后端接口)
			schemeList: [],
			budgetList: [],
			worksList: [],
			casesList: [],

			// 搜索关键词
			schemeName: '',
			schemeTags: '',
			budgetName: '',
			budgetTags: '',
			workName: '',
			workTags: '',
			caseName: '',
			caseTags: '',

			// 从 URL 进入时是否需要定位到内容区
			needScrollContent: false,
		}
	},
	computed: {
		// 各列表按时间倒序排列(用于时间轴)
		sortedScheme() { return this.sortByTime(this.schemeList) },
		sortedBudget() { return this.sortByTime(this.budgetList) },
		sortedWorks() { return this.sortByTime(this.worksList) },
		sortedCases() { return this.sortByTime(this.casesList) },
	},
	watch: {
		// 详情页面包屑跳回本页(路径同为 /projectProposal,可能仅 query 变化)时重新定位 tab
		'$route'() { this.applyRouteQuery(this.$route.query) },
	},
	created() {
		this.applyRouteQuery(this.$route.query)
	},
	mounted() {
		this.loadScheme()
		this.loadBudget()
		this.loadWorks()
		this.loadCases()
		// 详情面包屑返回后，滚动到 Tab 内容区
		if (this.needScrollContent) {
			this.$nextTick(() => {
				const el = this.$refs.contentArea
				if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' })
			})
		}
	},
	methods: {
		// 根据 URL query 切换 Tab
		applyRouteQuery(q) {
			q = q || {}
			if (q.tab === 'budget' || q.tab === 'works' || q.tab === 'cases') {
				this.activeTab = q.tab
				this.needScrollContent = true
			}
		},
		switchTab(tab) { this.activeTab = tab },

		// 时间轴排序:按 created_at 倒序
		sortByTime(list) {
			if (!Array.isArray(list)) return []
			return [...list].sort((a, b) => {
				const t = (v) => new Date((v || '').replace(' ', 'T')).getTime() || 0
				return t(b.created_at) - t(a.created_at)
			})
		},
		// 日期只取年月日
		fmtDate(v) {
			if (!v) return ''
			return String(v).slice(0, 10)
		},

		// 通用分拆 tags(可能以逗号/顿号分隔)
		splitTags(tags) {
			if (!tags) return []
			return String(tags).split(/[,，]/).map(s => s.trim()).filter(Boolean)
		},

		// ---- 方案列表 ----
		loadScheme() {
			this.$axios.get(this.$api + '/getHtmlPage', {
				params: { style: 'html', name: this.schemeName || undefined, tags: this.schemeTags || undefined }
			}).then(res => {
				this.schemeList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// ---- 报价列表 ----
		loadBudget() {
			this.$axios.get(this.$api + '/getHtmlPage', {
				params: { style: 'page', name: this.budgetName || undefined, tags: this.budgetTags || undefined }
			}).then(res => {
				this.budgetList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// ---- 作品列表 ----
		loadWorks() {
			this.$axios.get(this.$api + '/getWorksCase', {
				params: { style: 'work', name: this.workName || undefined, tags: this.workTags || undefined }
			}).then(res => {
				this.worksList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// ---- 案例列表 ----
		loadCases() {
			this.$axios.get(this.$api + '/getWorksCase', {
				params: { style: 'case', name: this.caseName || undefined, tags: this.caseTags || undefined }
			}).then(res => {
				this.casesList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},

		// ---- 跳转详情 ----
		toSchemeDetail(id) { this.$router.push({ path: '/schemeDetail', query: { id } }) },
		toBudgetDetail(id) { this.$router.push({ path: '/budgetDetail', query: { id } }) },
		toWorkDetail(id) { this.$router.push({ path: '/workDetail', query: { id } }) },
		toCaseDetail(id) { this.$router.push({ path: '/caseDetail', query: { id } }) },
	},
}
</script>

<style scoped>
/* 顶部 banner 区(站内风格) */
.videolist-banner {
	width: 100%;
	height: 700px;
	background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg);
	background-size: 100% 100%;
	position: relative;
}
.bannertop-title { width: 100%; position: absolute; left: 0; top: 30%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 61px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 35px auto 0; font-size: 31px; color: #fff; text-align: right; letter-spacing: 2px; }

/* 主体内容区 */
.app-container { max-width: 1280px; margin: 0 auto; padding: 2rem 1.5rem 4rem; }
.page-header { margin-bottom: 2rem; }
.page-header h1 { font-size: 1.75rem; font-weight: 600; color: #0a2540; display: flex; align-items: center; gap: .75rem; }
.page-header h1 i { color: #2563eb; }

/* Tab */
.tabs { display: flex; gap: .25rem; background: #fff; padding: .5rem 1rem 0; border-radius: 16px 16px 0 0; border-bottom: 2px solid #e9edf4; flex-wrap: wrap; }
.tab-btn { background: transparent; border: none; padding: .75rem 1.5rem; font-size: .95rem; font-weight: 500; color: #64748b; cursor: pointer; border-bottom: 3px solid transparent; transition: all .2s; border-radius: 8px 8px 0 0; display: flex; align-items: center; gap: .5rem; }
.tab-btn i { font-size: 1rem; opacity: .7; }
.tab-btn:hover { color: #1e293b; background: #f8fafc; }
.tab-btn.active { color: #2563eb; border-bottom-color: #2563eb; background: #f8fafc; font-weight: 600; }
.tab-btn.active i { opacity: 1; }

.tab-panel { background: #fff; border-radius: 0 0 16px 16px; padding: 1.5rem 1.5rem 2rem; box-shadow: 0 4px 12px rgba(0,0,0,.03); min-height: 420px; }

/* 工具栏 + 搜索 */
.panel-toolbar { margin-bottom: 1.25rem; }
.search-wrap { display: flex; gap: .5rem; flex-wrap: wrap; }
.search-input { flex: 1; min-width: 160px; padding: .5rem .75rem; border: 1px solid #e2e8f0; border-radius: 8px; font-size: .9rem; outline: none; }
.search-input:focus { border-color: #2563eb; }
.search-btn { background: #2563eb; color: #fff; border: none; padding: .5rem 1.2rem; border-radius: 8px; font-weight: 500; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: .3rem; transition: background .2s; }
.search-btn:hover { background: #1d4ed8; }

/* 时间轴列表：每行 = marker列(点+竖线) + 内容列，点自然落在线上 */
.timeline { margin-top: .5rem; }
.timeline-item { position: relative; display: flex; cursor: pointer; }
.timeline-item .tl-marker {
	position: relative;
	width: 28px;               /* marker 列固定宽度 */
	flex: 0 0 28px;
	display: flex;
	justify-content: center;
}
/* 竖线：贯穿每个 item，连接上下圆点 */
.timeline-item .tl-marker::before {
	content: '';
	position: absolute;
	left: 50%;
	top: 0;
	bottom: 0;
	width: 2px;
	transform: translateX(-50%);
	background: #e2e8f0;
}
/* 圆点：正好画在线条顶端中心 */
.timeline-item .tl-marker::after {
	content: '';
	position: absolute;
	top: 4px;
	left: 50%;
	transform: translateX(-50%);
	width: 14px;
	height: 14px;
	background: #2563eb;
	border-radius: 9999px;
	border: 2px solid #fff;
	box-shadow: 0 0 0 3px #dbeafe;
	z-index: 1;
}
/* 最后一项：不向下画多余线条 */
.timeline-item:last-child .tl-marker::before { bottom: auto; height: 10px; }

/* 内容列 */
.timeline-item .tl-body { flex: 1; min-width: 0; padding-bottom: 1.5rem; }
.tl-date { font-size: .8rem; font-weight: 600; color: #2563eb; letter-spacing: .3px; margin-bottom: .3rem; text-align: left; }
.tl-card { padding: .75rem 1rem; background: #fafcff; border-radius: 10px; border: 1px solid #eef2f6; transition: all .15s; text-align: left; }
.tl-card:hover { background: #fff; border-color: #dbeafe; box-shadow: 0 2px 8px rgba(0,0,0,.03); }
.tl-title { font-weight: 600; font-size: 1rem; color: #0a2540; text-align: left; }
.tl-tags { display: flex; flex-wrap: wrap; gap: .3rem; margin-top: .3rem; text-align: left; }
.tl-tags span { background: #f1f5f9; font-size: .7rem; padding: .1rem .6rem; border-radius: 12px; color: #475569; }
.tl-hint { display: inline-flex; align-items: center; gap: .2rem; font-size: .7rem; color: #94a3b8; margin-top: .35rem; transition: color .2s; }
.tl-hint i { font-size: .6rem; display: inline-block; transform: rotate(-90deg); }
.timeline-item:hover .tl-hint { color: #2563eb; }
.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

/* 响应式 */
@media (max-width: 768px) {
	.videolist-banner { height: 380px; }
	.bannertop-title { top: 40%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	.tab-btn { padding: .6rem .9rem; font-size: .85rem; }
	.tab-btn i { display: none; }
}
@media (max-width: 480px) { .tabs { overflow-x: auto; flex-wrap: nowrap; padding: .5rem .5rem 0; } .tab-btn { white-space: nowrap; } }
</style>

<style>
@import '../assets/css/alibaba.css';
</style>